import { NotificationValues } from '../../pages/Config/Notifications';
import { PasswordValues } from '../../pages/Config/PasswordChange';
import { ProfileValues } from '../../pages/Config/Profile';
import { api } from '../../services/api';
import { InvitedUser, RegisterInvitedData, SaveProfileResponse } from './types';

export const sendInvite = async (email: string) => {
  const response = await api.post<{ invited_user: InvitedUser }>(
    'customer/invited/invite',
    { email }
  );
  return response.data;
};

export const registerUser = async (
  token: string,
  password: string,
  password_confirm: string
) => {
  await api.post('customer/register', {
    token,
    password,
    password_confirm,
  });
};

export const registerInvited = async (data: RegisterInvitedData) => {
  await api.patch('customer/invited/register', data);
};

export const changePassword = async (data: PasswordValues) => {
  await api.patch('/customer/change-password', data);
};

export const getAllInvitedUsers = async () => {
  const response = await api.get<{ invited_users: InvitedUser[] }>(
    '/customer/invited'
  );
  return response.data;
};

export const deleteInvitedUser = async (id: number) => {
  await api.delete(`/customer/invited/${id}`);
};

export const changeNotifications = async (data: NotificationValues) => {
  await api.patch('/customer/change-notifications', data);
};

export const saveProfile = async (data: ProfileValues) => {
  const response = await api.put<SaveProfileResponse>(
    '/customer/profile',
    data
  );
  return response.data;
};
